<template>
  <div>
    <!-- Single Dialog -->
    <a
      @click.prevent="handleDialog"
      :href="`#providers-history-${_uid}`"
      class="link-underline">
      <i class="fa fa-list"></i>
      Visualizar Providers
    </a>
    <single-dialog
      :active="active"
      :large="true"
      @handleDialog="handleDialog">
      <template v-slot:body>
        <div
          :id="`providers-history-${_uid}`"
          class="table-responsive col-sm-12">
          <table class="table">
            <thead>
              <tr>
                <th>Provider</th>
                <th>Criação</th>
                <th>Atualizado</th>
                <th>Usuário</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in history"
                :key="`providers-history-${index}`">
                <td>
                  <provider-image
                    :imageSrc="item.provider.slug"
                    class="small-img" />
                  {{ item.provider.name }}
                </td>
                <td>{{ item.creation_date | brDate }}</td>
                <td>{{ item.modification_date | brDate }}</td>
                <td>{{ item.last_user.name }}</td>
                <td>{{ item.active ? 'Ativo' : 'Inativo' }}</td>
                <td>
                  <button
                    @click.prevent="handleAction(item.provider.id)"
                    type="button"
                    class="btn btn-link">
                    <i class="fa fa-edit"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </single-dialog>
  </div>
  <!-- // Single Dialog -->
</template>

<script>
import SingleDialog from '@/components/ui/SingleDialog';
import ProviderImage from '@/views/dashboard/providers/ProviderImage'

export default {
  components: {
    SingleDialog,
    ProviderImage
  },
  props: ['history'],
  data () {
    return {
      active: false
    }
  },
  methods: {
    handleDialog () {
      this.active = !this.active
    },
    handleAction (provider) {
      this.active = false
      this.$emit('handleAction', provider)
    }
  }
}
</script>
